const METERS_PER_MILE = 1609.344;

// Rounded to one decimal place, e.g. "0.6"
export const metersToMiles = (meters: number): string =>
  (meters / METERS_PER_MILE).toFixed(1);

export const getRegionsInCountry = <T extends { country: string }>(
  regions: T[],
  country: string
): T[] => regions.filter(region => region.country === country);

export const getCountiesInRegion = <T extends { region: string }>(
  counties: T[],
  region: string
): T[] => counties.filter(county => county.region === region);

export const getCitiesInCounty = <T extends { county: string }>(
  cities: T[],
  county: string
): T[] => cities.filter(city => city.county === county);
